import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

const LayoutContext = createContext(null);

export function LayoutProvider({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem("sidebar:collapsed");
    return saved ? JSON.parse(saved) : false;
  });

  const [isMobile, setIsMobile] = useState(false);

  // se o utilizador clicou manualmente (override), não mexer automaticamente
  const userOverrode = useRef(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(max-width: 992px)");

    // aplicar estado inicial (auto) se não houver override guardado
    if (!localStorage.getItem("sidebar:collapsed")) {
      setCollapsed(mq.matches);
    }

    // estado inicial de isMobile
    setIsMobile(mq.matches);

    const handleChange = (e) => {
      setIsMobile(e.matches);
      if (userOverrode.current) return; // respeita escolha manual
      setCollapsed(e.matches);
    };

    // Safari/Chrome modernos: 'change'; fallback antigo: addListener/removeListener
    if (mq.addEventListener) mq.addEventListener("change", handleChange);
    else mq.addListener?.(handleChange);

    return () => {
      if (mq.removeEventListener)
        mq.removeEventListener("change", handleChange);
      else mq.removeListener?.(handleChange);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem("sidebar:collapsed", JSON.stringify(collapsed));
  }, [collapsed]);

  const toggleSidebar = () => {
    userOverrode.current = true;
    setCollapsed((c) => !c);
  };

  const value = useMemo(
    () => ({ collapsed, toggleSidebar, setCollapsed, isMobile }),
    [collapsed, isMobile]
  );

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
}

export function useLayout() {
  const ctx = useContext(LayoutContext);
  if (!ctx) throw new Error("useLayout must be used within <LayoutProvider>");
  return ctx;
}
